
export default "/assets/envelope-mini.727ae1bd.svg"